import { useEffect, useRef } from 'react';
import { useAppStore } from '@/store/useAppStore';
import { saveToLocalStorage } from '@/store/persistence';

export function useAutoSave(): void {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    const unsubscribe = useAppStore.subscribe((state) => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        saveToLocalStorage(state.courses, state.settings, state.collegeShortlist).catch((e) => {
          console.warn('Auto-save failed:', e);
        });
      }, 500);
    });

    return () => {
      unsubscribe();
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
}
